// extracted by mini-css-extract-plugin
export default {"Content":"_HIaZ_ZHDc8_t56g3XaO","Heading":"GFGwWJklzx3pBlaUFPNh","SvgIcon":"kRvAQDbqyVQHxiESotlA","ConfirmationMessage":"GcGwXRZzusjGpIOrAxAX","Button":"mv8uTEyCdDrM2I4dZiKL"};